import { RoutesService } from './common/utils/routes.service';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { defaultPageScrollConfig } from 'ngx-page-scroll-core';
import { IdleService } from './common/utils/idle.service';
import { Location } from '@angular/common';
import { DATA_LOSS_WHITELIST } from './common/constants/Defines';
import { TrackingInterceptor } from '@vfde-fe/ngx-lib/plugins/tracking';
import { SpinnerService } from '@vfde-fe/ngx-lib/components/spinner';
import { AccordionInterceptor } from '@vfde-fe/ngx-lib/components/accordion';
import { SpinnerStatus } from '@vfde-fe/ngx-lib/components/spinner';
import { ConfirmDataLossService } from '@vfde-fe/ngx-lib/services/confirm-data-loss';
import { Spinner } from '@vfde-fe/ngx-lib/components/spinner';

/** AppComponent */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  /** boolean value to indicate if spinner loader is shows up or not */
  public generalLoader = false;
  /** spinner */
  public spinner: Spinner;
  public constructor (
      translate: TranslateService,
      spinnerService: SpinnerService,
      idleService: IdleService,
      private routesService: RoutesService,
      private trackingInterceptor: TrackingInterceptor,
      private accordionInterceptor: AccordionInterceptor,
      private location: Location,
      private confirmDataLossService: ConfirmDataLossService,
    ) {
        const base = document.getElementsByTagName('base')[0];

        base.setAttribute('href', '/simplicity/onelogin/js/');

    // if application is loaded with a H&S accordion opened. this removes the hash to close the accordion
    if (location.path(true).indexOf('#') !== -1) {
                location.go(location.path(true).split('#')[0]);
    }
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('defaultWording');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('deWording');
    // execute general loader callback with this to use generalLoader property
    spinnerService.generalLoaderCallback(this.switchGeneralLoaderSpinner, this);

    /** page scrolling configuration */
    defaultPageScrollConfig.scrollOffset = 10;

    // add whitelist to data loss service
    confirmDataLossService.whitelistUrls = DATA_LOSS_WHITELIST;

    // Start Idle service
    //WFAT-17537 - 2FA | Remove timeout from Non Logged In pages
    //idleService.start();

    // Start accordion interceptor
    accordionInterceptor.init();

    // Start tracking Interceptor
    trackingInterceptor.init();
  }

  /**
   * switch the boolean indicator to load the spinner or show the router outlet
   */
  private switchGeneralLoaderSpinner (that: any, spinnerStatus: SpinnerStatus, spinner?: Spinner) {
    that.spinner = spinner;
    that.generalLoader = (spinnerStatus === SpinnerStatus.START) ? true : false;
 }

}
